module.exports = __webpack_public_path__ + "img/batch-update.42b3964b.svg";